module.exports = __webpack_public_path__ + "static/successful-farming-ag.fe43b73b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/successful-farming-ag.svg
// module id = 608
// module chunks = 35783957827783